import { Component } from '@angular/core';
import { TooltipService } from 'app/widgets/tooltip.service';

@Component({
	selector: 'uc-delivers-story-link',
	templateUrl: './uc-delivers-story-link.component.html',
	styleUrls: ['./uc-delivers-story-link.component.scss']
})
export class UcDeliversStoryLinkComponent {
	constructor(
		private tooltipSvc : TooltipService
	) {}

	getHref(): string {
		const defaultUrl = "https://ucanr.edu/blog/uc-delivers";
		return this.tooltipSvc.tooltip("UCDeliversURL") || defaultUrl;
	}
}
